import { PODFilesResponse } from '@/types/podFiles'
import { defineStore } from 'pinia'

interface States {
  podFiles: Ref<PODFilesResponse | null>
}

export const usePODFilesStore = defineStore('podFiles', () => {
  const states: States = {
    podFiles: ref(null),
  }

  const resetStore = () => {
    states.podFiles.value = null
  }

  return {
    ...states,
    resetStore,
  }
})
